
// import OurBrandsMap from './_our_brands_map';
// import HotelsMap from './_hotels_map';
// const Map = {
//     init() {
//         if ($('.jsMap').length > 0) {
//             this.initMap();
//         }
//     },
//     initMap() {
//         OurBrandsMap.init();
//         HotelsMap.init();
//     },
// }
// export default Map;


// WEBPACK FOOTER //
// ./scripts/modules/components/maps/_map.js